import React, { useEffect, useRef, useState } from "react";
import { getConsent, saveConsent, OPEN_SETTINGS_EVENT } from "../../lib/consent";

// UK PECR: analytics off until the visitor accepts. Equal weight buttons.
export default function CookieBanner() {
  const [mounted, setMounted] = useState(false);
  const [visible, setVisible] = useState(false);
  const [settingsOpen, setSettingsOpen] = useState(false);
  const [analytics, setAnalytics] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    // Keep the banner out of prerendered HTML and crawler snapshots.
    if (typeof navigator !== "undefined" && navigator.webdriver) return;
    setMounted(true);
    if (!getConsent()) setVisible(true);
    const open = () => {
      const c = getConsent();
      setAnalytics(c ? c.analytics : false);
      setSettingsOpen(true);
      setVisible(true);
    };
    window.addEventListener(OPEN_SETTINGS_EVENT, open);
    return () => window.removeEventListener(OPEN_SETTINGS_EVENT, open);
  }, []);

  // Pad the page so the banner never covers footer links.
  useEffect(() => {
    if (!visible) { document.body.style.paddingBottom = ""; return undefined; }
    const update = () => { if (ref.current) document.body.style.paddingBottom = `${ref.current.offsetHeight}px`; };
    update();
    window.addEventListener("resize", update);
    return () => { window.removeEventListener("resize", update); document.body.style.paddingBottom = ""; };
  }, [visible, settingsOpen]);

  if (!mounted || !visible) return null;

  const choose = (allow) => { saveConsent(allow); setVisible(false); setSettingsOpen(false); };

  return (
    <div ref={ref} className="cookie" role="region" aria-label="Cookie consent" data-testid="cookie-banner">
      <div className="wrap">
        {settingsOpen && (
          <div className="cookie-settings" data-testid="cookie-settings-panel">
            <div>
              <b>Analytics</b>
              <p style={{ marginTop: 2 }}>Helps us see which pages are used so we can improve the site. Off by default.</p>
            </div>
            <button type="button" role="switch" aria-checked={analytics} aria-label="Analytics cookies" className="switch"
              onClick={() => setAnalytics((v) => !v)} data-testid="cookie-analytics-toggle"><span /></button>
          </div>
        )}
        <p>We use essential cookies to run this site. With your permission we also use analytics cookies to see how the site is used. You can change your choice at any time in Cookie settings.</p>
        <div className="actions">
          {settingsOpen ? (
            <button type="button" className="btn btn-green" onClick={() => choose(analytics)} data-testid="cookie-save-button">Save</button>
          ) : (
            <>
              <button type="button" className="btn btn-ghost" onClick={() => choose(true)} data-testid="cookie-accept-button">Accept all</button>
              <button type="button" className="btn btn-ghost" onClick={() => choose(false)} data-testid="cookie-reject-button">Reject non-essential</button>
              <button type="button" className="link" onClick={() => setSettingsOpen(true)} data-testid="cookie-settings-link">Cookie settings</button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
